import { VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC, ReactNode } from "react";

interface StatsBoxProps {
  title: ReactNode;
}

const StatsBox: FC<React.PropsWithChildren<StatsBoxProps>> = ({
  title,
  children,
}) => (
  <VStack align="start" flex="1" spacing="1">
    <div className="text-xl uppercase font-semibold">{title}</div>
    <div className="space-y-1">{children}</div>
  </VStack>
);

export default observer(StatsBox);
